import ListRow from './list-row.vue'
export default ListRow



// WEBPACK FOOTER //
// ./src/components/list-row/index.js